import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "card-label" }, "Equity Check", -1)
const _hoisted_5 = { class: "card-toolbar gap-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-3 table-hover" }
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "DIFF", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}

import { ref, onMounted } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TradeServices from "../services/TradeServices";
import ExcludeList from "@/projects/tenant/modules/trade/components/ExcludeList.vue";
import EmailTargetSelection from "@/projects/tenant/modules/trade/modals/EmailTargetSelection.vue";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import TableFooter from "@/components/TableFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EquityCheck',
  setup(__props) {

const isLoading = ref(false);
const checklist = ref(Array<any>());
const excludeListRef = ref<any>(null);
const emailTargetSelectionRef = ref<any>(null);
const isReloading = ref(false);

const criteria = ref<any>({
  page: 1,
  size: 20,
  numPages: 1,
  total: 0,
});

const showExcludeList = () => {
  excludeListRef.value?.show();
};

const showEmailTargetSelection = (_item: any) => {
  emailTargetSelectionRef.value?.show(_item);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;

  try {
    const res = await TradeServices.getEquityBelowCredit(criteria.value);
    checklist.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }

  isLoading.value = false;
};

const reload = () => {
  isReloading.value = true;
  SystemService.reloadConfiguration().then(() => {
    isReloading.value = false;
  });
};

const clear = () => {
  criteria.value = {
    page: 1,
    size: 20,
    numPages: 1,
    total: 0,
  };

  fetchData(1);
};

const onEventSubmitted = () => {
  fetchData(1);
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_input, {
          class: "w-200px",
          modelValue: criteria.value.accountNumber,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.accountNumber) = $event)),
          clearable: true,
          placeholder: "Account Number"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          class: "w-200px ms-3",
          modelValue: criteria.value.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.email) = $event)),
          clearable: true,
          placeholder: "Email"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          class: "ms-3",
          type: "success",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Search")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "ms-3",
          type: "info",
          onClick: clear
        }, {
          default: _withCtx(() => [
            _createTextVNode("Clear")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: showExcludeList,
          disabled: isReloading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Excluded List")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: reload
        }, {
          default: _withCtx(() => [
            _createTextVNode("Reload")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_8, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.service")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.group")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.margin")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.credit")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.equity")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.balance")), 1),
            _hoisted_9,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && checklist.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklist.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(item.nativeName), 1),
                        _createElementVNode("div", null, _toDisplayString(item.email), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(item.serviceName), 1),
                        _createElementVNode("div", null, _toDisplayString(item.mtGroup), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.agentGroup), 1),
                    _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(item.margin), 1),
                    _createElementVNode("td", null, _toDisplayString(item.credit), 1),
                    _createElementVNode("td", null, _toDisplayString(item.equity), 1),
                    _createElementVNode("td", null, _toDisplayString(item.balance), 1),
                    _createElementVNode("td", null, _toDisplayString((item.credit - item.equity).toFixed(2)), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        size: "small",
                        onClick: ($event: any) => (showEmailTargetSelection(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.sendEmail")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(ExcludeList, {
      ref_key: "excludeListRef",
      ref: excludeListRef,
      onEventSubmit: onEventSubmitted
    }, null, 512),
    _createVNode(EmailTargetSelection, {
      ref_key: "emailTargetSelectionRef",
      ref: emailTargetSelectionRef
    }, null, 512)
  ]))
}
}

})